var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProperty1Gold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_161_31772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.63316 31.4542L3.81055 40.7258H17.7993L13.2856 31.4542H7.63316Z",
    stroke: "#0BAB47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2151 31.4542L17.3926 40.7258H31.3806L26.8667 31.4542H21.2151Z",
    stroke: "#0BAB47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7971 31.4541L30.9746 40.7256H44.9634L40.4495 31.4541H34.7971Z",
    stroke: "#0BAB47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0833 21.824L10.2607 31.0955H24.2495L19.7356 21.824H14.0833Z",
    stroke: "#0BAB47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6645 21.8237L23.8418 31.0953H37.8306L33.3169 21.8237H27.6645Z",
    stroke: "#0BAB47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0774 11.9427L17.2549 21.2143H31.2444L26.7305 11.9427H21.0774Z",
    stroke: "#0BAB47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.528 11.4313H12.1934",
    stroke: "#0BAB47",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8145 9.14502V3.81042",
    stroke: "#0BAB47",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8184 19.0521V12.9554",
    stroke: "#0BAB47",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3418 21.3384H43.4385",
    stroke: "#0BAB47",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.731 11.9426H21.0786L17.2568 21.2142H31.2456L26.731 11.9426ZM25.911 14.4796H22.1006C21.8985 14.4796 21.7047 14.3993 21.5618 14.2564C21.4189 14.1135 21.3385 13.9196 21.3385 13.7175C21.3385 13.5154 21.4189 13.3216 21.5618 13.1787C21.7047 13.0357 21.8985 12.9554 22.1006 12.9554H25.911C26.1132 12.9554 26.3069 13.0357 26.4499 13.1787C26.5928 13.3216 26.6731 13.5154 26.6731 13.7175C26.6731 13.9196 26.5928 14.1135 26.4499 14.2564C26.3069 14.3993 26.1132 14.4796 25.911 14.4796Z",
    fill: "#0BAB47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_161_31772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty1Gold);
export default __webpack_public_path__ + "static/media/Property 1=gold.b0f6095f9ce1ca2cf5b2d4fdb1135f81.svg";
export { ForwardRef as ReactComponent };